import { slicedToArray as _slicedToArray, defineProperty as _defineProperty } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React, { useState, useEffect } from 'react';
import { SingleDatePicker } from '@deal/components';
import { usePathContext } from '../../../context/PathContext.js';
import classNames from 'classnames';
import format from 'date-fns/format';
import styles from './styles.css.js';

var INTL_SIMPLE_DATE_KEBAB_FORMAT = 'yyyy-MM-dd';

var DateQuestion = function DateQuestion(_ref) {
  var question = _ref.question,
      loading = _ref.loading,
      onQuestionUpdated = _ref.onQuestionUpdated,
      onQuestionValidityChanged = _ref.onQuestionValidityChanged;
  var pathContext = usePathContext();
  var dateQuestion = question;
  var initialDateValue = dateQuestion.dateValue ? new Date("".concat(dateQuestion.dateValue, " 00:00")) : undefined;

  var _useState = useState(initialDateValue || undefined),
      _useState2 = _slicedToArray(_useState, 2),
      selectedDate = _useState2[0],
      setSelectedDate = _useState2[1];

  var populateDateValue = function populateDateValue(updatedDate) {
    var _a;

    onQuestionUpdated({
      id: (_a = pathContext.activeNode) === null || _a === void 0 ? void 0 : _a.id,
      dateQuestion: {
        questionId: question.id,
        value: updatedDate ? format(new Date(updatedDate), INTL_SIMPLE_DATE_KEBAB_FORMAT) : undefined
      }
    });
    /**
     * If the question is reqiured, is there a date present, otherwise it's valid
     */

    onQuestionValidityChanged(question.commonFields.required ? !!updatedDate : true);
  };

  useEffect(function () {
    /**
     * Use the `question.dateValue` reference instead of `initialDateValue` so we don't
     * needlessly convert it to a Date then back to a string
     */
    if (dateQuestion.dateValue) {
      populateDateValue(dateQuestion.dateValue);
    }
  }, []);
  return React.createElement("div", {
    className: classNames(styles.input, _defineProperty({}, styles.placementModal, pathContext.pathPlacement === 'modal'))
  }, React.createElement(SingleDatePicker, {
    numberOfMonths: 1,
    id: question.id,
    date: selectedDate,
    disabled: loading,
    labelHidden: true,
    keepOpenOnDateSelect: false,
    onDateChange: function onDateChange(updatedDate) {
      setSelectedDate(updatedDate);

      if (updatedDate) {
        var formattedDate = format(updatedDate, INTL_SIMPLE_DATE_KEBAB_FORMAT);
        populateDateValue(formattedDate);
      } else {
        populateDateValue(undefined);
      }
    }
  }));
};

export default DateQuestion;
//# sourceMappingURL=index.js.map
